<template>
    <Fragment>
        <button
            v-if="inPurchases"
            class="btn btn_lg btn_common btn_icontext ci_action_cart mt_xs"
            data-toggle="modal"
            :data-target="'#modalPurchaseRequest' + id"
        >
            <i class="f7-icons icon_lg">bolt_circle</i>
            Заявка отправлена
        </button>

        <button
            v-else
            class="btn btn_lg btn_common btn_icontext ci_action_cart mt_xs"
            data-toggle="modal"
            :data-target="'#modalPurchaseRequest' + id"
        >
            <i class="f7-icons icon_lg">bolt_circle</i>
            Оформить заявку
        </button>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {
    props: ["id"],

    components: { Fragment },

    data: function () {
        return {
        };
    },

    computed: {
        inPurchases() {
            return this.$store.state.purchases.items.find(x => x.id == this.id);
        }
    },

    methods: {
        addToPurchases() {
            this.$store.dispatch('purchases/addToPurchases', this.id)
        },
    },
};
</script>
